<template>
  <div class="sys-config-container">
    <el-card class="config-card">
      <div class="card-header">
        <h2>系统配置</h2>
        <el-button type="primary" size="small" @click="refreshCache">刷新缓存</el-button>
      </div>
      
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="订单配置" name="order">
          <el-form 
            ref="orderConfigForm" 
            :model="orderConfigForm" 
            :rules="orderConfigRules" 
            label-width="250px" 
            status-icon>
            <el-form-item 
              label="订单即将超期天数" 
              prop="order_expiring_days">
              <el-input-number 
                v-model.number="orderConfigForm.order_expiring_days" 
                :min="1"
                controls-position="right"
                style="width: 100%">
              </el-input-number>
              <span class="unit-text">天</span>
            </el-form-item>
            
            <el-form-item 
              label="订单自动进入结算天数" 
              prop="order_auto_settlement_days">
              <el-input-number
                v-model.number="orderConfigForm.order_auto_settlement_days"
                :min="1"
                controls-position="right"
                style="width: 100%">
              </el-input-number>
              <span class="unit-text">天</span>
            </el-form-item>
            
            <el-form-item 
              label="复测订单自动进入结算天数" 
              prop="retest_order_auto_settlement_days">
              <el-input-number
                v-model.number="orderConfigForm.retest_order_auto_settlement_days"
                :min="1"
                controls-position="right"
                style="width: 100%">
              </el-input-number>
              <span class="unit-text">天</span>
            </el-form-item>
            
            <el-form-item 
              label="在途订单自动进入测试中天数" 
              prop="transit_order_auto_testing_days">
              <el-input-number
                v-model.number="orderConfigForm.transit_order_auto_testing_days"
                :min="1"
                controls-position="right"
                style="width: 100%">
              </el-input-number>
              <span class="unit-text">天</span>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="saveOrderConfig" :loading="saving">保存配置</el-button>
              <el-button @click="resetForm('orderConfigForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'SysConfig',
  data() {
    return {
      activeTab: 'order',
      loading: false,
      saving: false,
      orderConfigForm: {
        order_expiring_days: '',
        order_auto_settlement_days: '',
        retest_order_auto_settlement_days: '',
        transit_order_auto_testing_days: ''
      },
      orderConfigRules: {
        // 规则定义在模板中
      }
    }
  },
  created() {
    this.fetchOrderConfigs()
  },
  methods: {
    fetchOrderConfigs() {
      this.loading = true
      adminApi.getSysConfigsByType('order')
        .then(response => {
          if (response) {
            const configList = response
            configList.forEach(config => {
              this.orderConfigForm[config.configKey] = config.configValue
            })
          }
          this.loading = false
        })
        .catch(error => {
          console.error('获取订单配置失败:', error)
          this.$message.error('获取订单配置失败')
          this.loading = false
        })
    },
    saveOrderConfig() {
      this.$refs.orderConfigForm.validate(valid => {
        if (valid) {
          this.saving = true
          
          // 准备更新的数据
          const configMap = { ...this.orderConfigForm }
          
          adminApi.batchUpdateSysConfig(configMap)
            .then(response => {
              if (response) {
                this.$message.success(response.msg || '保存配置成功')
                // 刷新配置缓存
                this.refreshCache()
              } else {
                this.$message.error(response.msg || '保存配置失败')
              }
              this.saving = false
            })
            .catch(error => {
              console.error('保存配置失败:', error)
              this.$message.error('保存配置失败')
              this.saving = false
            })
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.fetchOrderConfigs()
    },
    refreshCache() {
      adminApi.refreshSysConfigCache()
        .then(response => {
          if (response) {
            this.$message.success(response.msg || '刷新缓存成功')
          } else {
            this.$message.error(response.msg || '刷新缓存失败')
          }
        })
        .catch(error => {
          console.error('刷新缓存失败:', error)
          this.$message.error('刷新缓存失败')
        })
    }
  }
}
</script>

<style scoped>
.sys-config-container {
  padding: 20px;
}

.config-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.unit-text {
  margin-left: 10px;
}

/* 确保数字输入框的宽度合适 */
.el-input-number {
  width: calc(100% - 40px) !important;
}

/* 数字输入框内的数字左对齐 */
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
</style> 